import {
  KeyboardShortcut as KeyboardShortcutComponent,
  KeyboardShortcutIndicator
} from './KeyboardShortcut'

export const KeyboardShortcut = Object.assign(KeyboardShortcutComponent, {
  Indicator: KeyboardShortcutIndicator
})

KeyboardShortcut.displayName = 'KeyboardShortcut'
